import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _1a7dd3fe = () => interopDefault(import('..\\pages\\error.vue' /* webpackChunkName: "pages_error" */))
const _eaf81288 = () => interopDefault(import('..\\pages\\path.vue' /* webpackChunkName: "pages_path" */))
const _020f0331 = () => interopDefault(import('..\\pages\\reimbursement\\index.vue' /* webpackChunkName: "pages_reimbursement_index" */))
const _65294f02 = () => interopDefault(import('..\\pages\\rejection.vue' /* webpackChunkName: "pages_rejection" */))
const _7d75bb05 = () => interopDefault(import('..\\pages\\selection.vue' /* webpackChunkName: "pages_selection" */))
const _597bb2ca = () => interopDefault(import('..\\pages\\unlock.vue' /* webpackChunkName: "pages_unlock" */))
const _26a1f3e0 = () => interopDefault(import('..\\pages\\enroll\\eligibility.vue' /* webpackChunkName: "pages_enroll_eligibility" */))
const _d81e1792 = () => interopDefault(import('..\\pages\\enroll\\patient-information.vue' /* webpackChunkName: "pages_enroll_patient-information" */))
const _1dc0ab81 = () => interopDefault(import('..\\pages\\enroll\\prescriber-information.vue' /* webpackChunkName: "pages_enroll_prescriber-information" */))
const _16fe0a54 = () => interopDefault(import('..\\pages\\enroll\\success.vue' /* webpackChunkName: "pages_enroll_success" */))
const _1727f03c = () => interopDefault(import('..\\pages\\errors\\400.vue' /* webpackChunkName: "pages_errors_400" */))
const _170bc13a = () => interopDefault(import('..\\pages\\errors\\401.vue' /* webpackChunkName: "pages_errors_401" */))
const _16d36336 = () => interopDefault(import('..\\pages\\errors\\403.vue' /* webpackChunkName: "pages_errors_403" */))
const _16b73434 = () => interopDefault(import('..\\pages\\errors\\404.vue' /* webpackChunkName: "pages_errors_404" */))
const _29524323 = () => interopDefault(import('..\\pages\\errors\\500.vue' /* webpackChunkName: "pages_errors_500" */))
const _a20a106a = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages_index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('#{BasePath}#/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/error",
    component: _1a7dd3fe,
    name: "error"
  }, {
    path: "/path",
    component: _eaf81288,
    name: "path"
  }, {
    path: "/reimbursement",
    component: _020f0331,
    name: "reimbursement"
  }, {
    path: "/rejection",
    component: _65294f02,
    name: "rejection"
  }, {
    path: "/selection",
    component: _7d75bb05,
    name: "selection"
  }, {
    path: "/unlock",
    component: _597bb2ca,
    name: "unlock"
  }, {
    path: "/enroll/eligibility",
    component: _26a1f3e0,
    name: "enroll-eligibility"
  }, {
    path: "/enroll/patient-information",
    component: _d81e1792,
    name: "enroll-patient-information"
  }, {
    path: "/enroll/prescriber-information",
    component: _1dc0ab81,
    name: "enroll-prescriber-information"
  }, {
    path: "/enroll/success",
    component: _16fe0a54,
    name: "enroll-success"
  }, {
    path: "/errors/400",
    component: _1727f03c,
    name: "errors-400"
  }, {
    path: "/errors/401",
    component: _170bc13a,
    name: "errors-401"
  }, {
    path: "/errors/403",
    component: _16d36336,
    name: "errors-403"
  }, {
    path: "/errors/404",
    component: _16b73434,
    name: "errors-404"
  }, {
    path: "/errors/500",
    component: _29524323,
    name: "errors-500"
  }, {
    path: "/",
    component: _a20a106a,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
